import "../style/form/productorderform.scss";
import { useDispatch, useSelector } from "react-redux";
import { productorder } from "../redux/reducer/counterslice";
import { useEffect, useState } from "react";
import { ProductOrderGet, trackorder } from "../../text/apidata";
import axios from "axios";
import { DatePicker, Stack } from "rsuite";
import DOMPurify from "dompurify";
import "rsuite/dist/rsuite.css";
import Swal from "sweetalert2";
import isBefore from 'date-fns/isBefore';
import noimage from "../../assets/images/noimage.png";
import pdf from "../../assets/images/pdf.png"


function ProductOrderForm(props) {
  const productstate = useSelector((state) => state.counter.productorder);
  const productid = useSelector((state) => state.counter.productorderid);
  const [status, setstatus] = useState([
    "Confirming order",
    "Ready to dispatch",
    "En route",
    "Delivered",
  ]);
  const [statusdata, setstatusdata] = useState("");
  const dispatch = useDispatch();
  const [trackorderdata, settrackorderdata] = useState({});
  const [productvalue, setproductvalue] = useState({
    status: "",
    assigned_to: "",
    assigned_by: "",
    phone_number: "",
    delivery_date: "",
  });
  const [cartproducts, setcartproduct] = useState([]);
  const [range, setrange] = useState([]);
  const [assignedtoer, setassignedtoer] = useState(false);
  const [assignedbyer, setassignedbyer] = useState(false);
  const [phoneer, setphoneer] = useState(false);
  const [valphoneer, setvalphoneer] = useState(false);
  const [alert, setalert] = useState(false);
  const [uploadprescription, setuploadprescription] = useState([]);
  const[statusval,setstatusval]=useState("")
  const [statuser, setstatuser] = useState(false);
  const [dateer, setdateer] = useState(false);
  const [createddate,setcreateddata]=useState()
  const [date,setdate]=useState([])
  const handlechangedate = (name, value, timeString) => {
    setalert(true);
console.log(value,name,timeString)
    if ((name = "delivery_date")) {
      if (value != null) {
        setrange((oldArray) => [
          ...oldArray,
          value.slice(0, 10) + " " + String(timeString).slice(0, 8),
        ]);
        setproductvalue({
          ...productvalue,
          [name]: value.slice(0, 10) + " " + String(timeString).slice(0, 8),
        });
        setdate(value)
  
      }
      if (value == "" || value == null) {
        setdateer(true);
      } else {
        setdateer(false);
      }
    }
  };
  
  const cleaningrange = () => {
    console.log(new Date(createddate),createddate)
    setrange([]);
    setdate()

    setproductvalue({
      ...productvalue,
      delivery_date: "",
    });
  };

  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
          dispatch(productorder(""));
          setalert(false);
        }
      });
    } else {
      dispatch(productorder(""));
      setalert(false);
    }
  };

  useEffect(() => {
    if (productstate == "Edit") {
      props.loaderchange("true");
      axios({
        method: "get",
        url: ProductOrderGet + productid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          console.log(res.data.data.cart_products);
          setcartproduct(res.data.data.cart_products);
          // console.log(String(res.data.data.delivery_date).replace("T", " "));
          setcreateddata(res.data.data.created_date)
          setstatusdata(res.data.data.status);
          setstatusval(res.data.data.status)
          setuploadprescription(res.data.data.upload_prescription);
          setproductvalue({
            ...productvalue,
            status: res.data.data.status,
            assigned_to: res.data.data.assigned_to,
            assigned_by: res.data.data.assigned_by,
            phone_number: res.data.data.phone_number,
            delivery_date: res.data.data.delivery_date,
          });
          setdate(res.data.data.delivery_date);
          props.loaderchange("false");
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
        });
    }
  }, [productstate]);

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const validation = (e) => {
    setalert(true);

    if (e.target.name == "assigned_to") {
      const { name, value } = e.target;
      setproductvalue({
        ...productvalue,
        [name]: value,
      });
      if (e.target.value == "") {
        setassignedtoer(true);
      } else {
        setassignedtoer(false);
      }
    }
    if (e.target.name == "assigned_by") {
      const { name, value } = e.target;
      setproductvalue({
        ...productvalue,
        [name]: value,
      });
      if (e.target.value == "") {
        setassignedbyer(true);
      } else {
        setassignedbyer(false);
      }
    }
    if (e.target.name == "status") {
      let key = "";
      var currentdate = new Date();
      setstatusval(e.target.value)
      const timeString = currentdate.toLocaleTimeString("en-US", {
        timeStyle: "medium",
      });
      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
      var localISOTime = new Date(currentdate - tzoffset)
        .toISOString()
        .slice(0, -1);
      const options = { year: "numeric", month: "short", day: "numeric" };
      const formattedDate = currentdate.toLocaleDateString("en-US", options);
      if (e.target.value == "Packing Order") {
        key = "order_packing";
      } else if (e.target.value == "In Transit") {
        key = "intransit";
      } else if (e.target.value == "Delivered") {
        key = "orderdelivered";
      }
      settrackorderdata({
        [key]: {
          time: String(formattedDate).replace(",", "") + " | " + timeString,
          status: true,
        },
      });

      console.log(
        String(formattedDate).replace(",", "") + " | " + timeString,
        trackorderdata
      );
      const { name, value } = e.target;
      setproductvalue({
        ...productvalue,
        [name]: value,
      });
      if (e.target.value == "") {
        setstatuser(true);
      } else {
        setstatuser(false);
      }
    }
    if (e.target.name == "phone_number") {
      const { name, value } = e.target;
      setproductvalue({
        ...productvalue,
        [name]: value,
      });
      if (value.length > 10) {
        setproductvalue({
          ...productvalue,
          [name]: value.slice(0, 10),
        });
      }

      if (e.target.value == "") {
        setphoneer(true);
      } else {
        setphoneer(false);
      }
    }
  };

  const newusercreate = () => {
    if (
      productvalue.status != "" &&
      productvalue.status != null &&
      ((statusdata == "In Transit"||statusdata =="Delivered"||statusval == "In Transit"||statusval =="Delivered")?
      productvalue.assigned_to != "" &&
      productvalue.assigned_to != null &&
      productvalue.assigned_by != "" &&
      productvalue.assigned_by != null &&
      productvalue.phone_number != "" &&
      productvalue.phone_number != null &&
      productvalue.phone_number.length == 10 :true)&&
      productvalue.status != "" &&
      productvalue.status != null &&
      productvalue.delivery_date != "" &&
      productvalue.delivery_date != null
    ) {
      props.loaderchange("true");

      axios({
        method: "put",
        url: ProductOrderGet + productid + "/",
        data: productvalue,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          console.log(res);
          axios({
            method: "put",
            url: trackorder + productid + "/",
            data: trackorderdata,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
          })
            .then((res) => {
              setalert(false);

              dispatch(productorder(""));
              props.popupalert("true");
              props.popuptext("Product Order Updated Successfully");

              setTimeout(() => {
                props.popupalert("false");
              }, 2000);

              props.loaderchange("false");
            })
            .catch((error) => {});
        })
        .catch((error) => {
          props.loaderchange("false");
        });
    } else {
      if (productvalue.status == "" || productvalue.status == null) {
        setstatuser(true);
      }
      if (productvalue.assigned_by == "" || productvalue.assigned_by == null) {
        setassignedbyer(true);
      }
      if (productvalue.assigned_to == "" || productvalue.assigned_to == null) {
        setassignedtoer(true);
      }
      if (
        productvalue.phone_number == "" ||
        productvalue.phone_number == null ||
        productvalue.phone_number.length != 10
      ) {
        setphoneer(true);
      }

      // if (productvalue.phone_number.length != 10) {
      //   setvalphoneer(true);
      // }

      if (
        productvalue.delivery_date == "" ||
        productvalue.delivery_date == null
      ) {
        setdateer(true);
      }
    }
  };
  console.log(productvalue.delivery_date)

  return (
    <>
      <div className="maincontainer_productform">
        <div className="parent-productform">
          <div className="create-productform card">
            <div class="modal-header">
              <h5 class="modal-title">
                {productstate == "Edit"
                  ? "Product Order Edit"
                  : "Product Order Create"}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => cancelnewuser(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="modal-body" style={{ padding: "0 !important" }}>
              <div className="produts_list">
                <label class="product_heading">Products</label>
                {cartproducts.map((data) => {
                  // return <p>{data.pharma.product_name}</p>;
                })}
              </div>
              <form
                style={{ padding: "0 1.5rem 0rem" }}
                className="formspace"
                onSubmit={handleSubmit}
              >
                <div class="form-row">
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom01" class="form-label">
                      Assigned To
                    </label>
                    <div style={{ display: "flex" }}>
                      <span
                        class="input-group-text"
                        id="inputGroupPrepend"
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        To
                      </span>

                      <input
                        type="text"
                        class="form-control"
                        id="validationCustom01"
                        name="assigned_to"
                        autoComplete="off"
                        style={{ borderRadius: " 0px 6px 6px 0px" }}
                        value={productvalue.assigned_to}
                        onKeyDown={(e) => {
                          if (e.target.value.length === 0 && e.which === 32) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => validation(e)}
                        disabled={statusdata == "In Transit"||statusdata =="Delivered"||statusval == "In Transit"||statusval =="Delivered"?false:true}

                      ></input>
                    </div>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {assignedtoer ? "Assigned to Required" : ""}{" "}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom01" class="form-label">
                      Assigned By
                    </label>
                    <div style={{ display: "flex" }}>
                      <span
                        class="input-group-text"
                        id="inputGroupPrepend"
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        By
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        id="validationCustom02"
                        name="assigned_by"
                        style={{ borderRadius: " 0px 6px 6px 0px" }}
                        autoComplete="off"
                        value={productvalue.assigned_by}
                        onChange={(e) => validation(e)}
                        onKeyDown={(e) => {
                          if (e.target.value.length === 0 && e.which === 32) {
                            e.preventDefault();
                          }
                        }}
                        disabled={statusdata == "In Transit"||statusdata =="Delivered"||statusval == "In Transit"||statusval =="Delivered"?false:true}


                        // rows="3"
                      ></input>
                    </div>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {assignedbyer ? "Assigned By Required" : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom01" class="form-label">
                      Phone Number
                    </label>
                    <div style={{ display: "flex" }}>
                      <input
                        type="number"
                        class="form-control"
                        id="validationCustom01"
                        name="phone_number"
                        autoComplete="off"
                        value={productvalue.phone_number}
                        onChange={(e) => validation(e)}
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                        disabled={statusdata == "In Transit"||statusdata =="Delivered"||statusval == "In Transit"||statusval =="Delivered"?false:true}

                      ></input>
                    </div>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {phoneer
                        ? valphoneer
                          ? "Enter a valid phonenumber"
                          : "Phone Number Required"
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="form-row">
                  <div class="form-group col-md-6 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Status
                    </label>
                    <select
                      class="form-select"
                      id="validationCustom04"
                      value={productvalue.status}
                      name="status"
                      onChange={(e) => validation(e)}
                    >
                      <option selected disabled value="">
                        Choose...
                      </option>
                      {/* {status.map((data) => {
                        return <option value={data}>{data}</option>;
                      })} */}
                      {statusdata == "Confirming order" ? (
                        <>
                          <option value={"Confirming order"} disabled>
                            Confirming order
                          </option>
                          <option value={"Packing Order"}>
                            Ready to dispatch
                          </option>
                          <option value={"In Transit"} disabled>
                            In Transit
                          </option>
                          <option value={"Delivered"} disabled>
                            Delivered
                          </option>
                        </>
                      ) : statusdata == "Packing Order" ? (
                        <>
                          <option value={"Confirming order"} disabled>
                            Confirming order
                          </option>
                          <option value={"Packing Order"} disabled>
                            Ready to dispatch
                          </option>
                          <option value={"In Transit"}>In Transit</option>
                          <option value={"Delivered"} disabled>
                            Delivered
                          </option>
                        </>
                      ) : statusdata == "In Transit" ? (
                        <>
                          <option value={"Confirming order"} disabled>
                            Confirming order
                          </option>
                          <option value={"Packing Order"} disabled>
                            Ready to dispatch
                          </option>
                          <option value={"In Transit"} disabled>
                            In Transit
                          </option>
                          <option value={"Delivered"}>Delivered</option>
                        </>
                      ) : statusdata == "Delivered" ? (
                        <>
                          <option value={"Confirming order"} disabled>
                            Confirming order
                          </option>
                          <option value={"Packing Order"} disabled>
                            Ready to dispatch
                          </option>
                          <option value={"In Transit"} disabled>
                            In Transit
                          </option>
                          <option value={"Delivered"}>Delivered</option>
                        </>
                      ) : (
                        <>
                          <option value={"Confirming order"}>
                            Confirming order
                          </option>
                          <option value={"Packing Order"}>
                            Ready to dispatch
                          </option>
                          <option value={"In Transit"}>In Transit</option>
                          <option value={"Delivered"}>Delivered</option>
                        </>
                      )}
                    </select>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {statuser ? "Status Required" : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-6 p-1 m-0 datepic">
                    <label for="validationCustom04" class="form-label">
                      Delivery Date
                    </label>
                    <DatePicker
                      format="yyyy-MM-dd HH:mm:ss"
                      showMeridian
                      style={{ width: "100%" }}
                      placement="rightEnd"
                      size="lg"
                      // locale={{
                      //   sunday: "Su",
                      //   monday: "Mo",
                      //   tuesday: "Tu",
                      //   wednesday: "We",
                      //   thursday: "Th",
                      //   friday: "Fr",
                      //   saturday: "Sa",
                      //   ok: "OK",
                      //   today: "Today",
                      //   yesterday: "Yesterday",
                      //   hours: "Hours",
                      //   minutes: "Minutes",
                      //   seconds: "Seconds",
                      // }}
                      disabledDate={date => isBefore(date, new Date(createddate))}
                      value={
                        // productvalue.delivery_date != "" &&
                        // productvalue.delivery_date != null &&
                        // productvalue.delivery_date != undefined
                        //   ? new Date(productvalue.delivery_date)
                        //   : null
                                                date != "" &&
                        date != null &&
                        date != undefined
                          ? new Date(date)
                          : null
                        
                      }
                      onClean={(e) => cleaningrange(e)}
                      onChange={(e) => {
                        if (e != null) {
                          setrange([]);
                          console.log(e);
                          const date = new Date(e);

                          const timeString = date.toLocaleTimeString("en-US", {
                            timeStyle: "medium",
                          });
                          var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                          var localISOTime = new Date(e - tzoffset)
                            .toISOString()
                            .slice(0, -1);
                          handlechangedate(
                            "delivery_date",
                            localISOTime,
                            timeString
                          );
                        }
                      }}
                    />
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {dateer ? "Date Time  Required" : ""}
                    </p>
                  </div>
                </div>
                {uploadprescription != null && (
                  <>
                    <div class="form-group col-md-12 p-1 m-0">
                      <label for="validationCustom04" class="form-label">
                        Upload Prescription
                      </label>
                    </div>

                    {uploadprescription.map((img) => {
                      return (
                        <>
                          <img
                            className="u_p"
                            src={
                              img!=null
                              ?( /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(String(img))?img
                              : pdf):noimage        
                            }
                            target="_blank"
                            onClick={(e) => {
                              {img!=null&&
                              window.open(img)}
                            }}

                          ></img>
                        </>
                      );
                    })}
                  </>
                )}
                <div
                  class="form-row"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group col-md-12 pb-3 pt-4 m-0">
                    <button
                      type="submit"
                      class="btn btn-primary  create"
                      onClick={(e) => newusercreate(e)}
                      disabled={!alert ? true : false}
                    >
                      Update ProductOrder
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductOrderForm;
